import SavedDrives from './SavedDrives';

export default SavedDrives;



// WEBPACK FOOTER //
// ./src/views/SavedDrives/index.js